import { application } from "./application"

import SelectTagsController from "./select_tags_controller"
application.register("select-tags", SelectTagsController)

import PinFormController from "./pin_form_controller"
application.register("pin-form", PinFormController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import InlineEditComponentController from "../../components/inline_edit/component_controller.js"
application.register("inline-edit", InlineEditComponentController)
